import PointsShopReward from './PointsShopReward'

export default PointsShopReward
